var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"type":"transition","enter-class":"grow-enter","enter-active-class":"grow-enter-active","enter-to-class":"grow-to","leave-to-class":"fly-away"},on:{"after-enter":_vm.onAngelCreated,"after-leave":_vm.deathComplete}},[_c('div',{staticClass:"cover cat-animation angel",style:(_vm.style)})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16164d46","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cat/Angel.vue
// module id = null
// module chunks = 